import React, { PropTypes } from "react";
import moment from "moment";
import Avatar from "components/Avatar/Avatar";
import CertificateLink from "./CertificateLink.jsx";
import constants from "constants";
import { cpdPoints, CPDPoints } from "components/CPDPoints";
import renderExperts from "components/Dashboard/renderExperts";
import renderSponsors from "components/Dashboard/renderSponsors";

const { CPD_STATUSES } = constants;

const CpdLiveItem = ({
  webinar: {
    id,
    webinar_title,
    start_date,
    end_date,
    sponsor,
    joined,
    cpd_status,
    experts,
    sponsors,
  },
  webinar,
  token,
  isMobile,
}) => {
  const isCertificateOfParticipation =
    webinar.ref_type === "certificate_of_participation";

  const isCustomCertificate = isCertificateOfParticipation;

  if (isMobile) {
    return (
      <div className="section_recorded">
        <p className="section_topic">{webinar_title}</p>
        <div className="section_info_mobile">
          <div className="section_topic_mobile">
            <div>
              <p className="current_card_date">
                <span>
                  {moment(start_date).format("MMM DD").toUpperCase()}{" "}
                </span>
                {moment(start_date).format("YYYY")}
              </p>
              <p className="current_card_time">
                {moment(start_date).format("h:mm a").toUpperCase()}
                {" - "}
                {moment(end_date).format("h:mm a").toUpperCase()}
              </p>
            </div>
          </div>
          {renderExperts(experts)}
          <div className="section_sponsors_mobile">
            <div>
              {sponsors && sponsors.length && sponsors.length > 0 ? (
                <div>
                  <p>Brought to you by:</p>
                  {renderSponsors(sponsor, sponsors, false)}
                </div>
              ) : null}
            </div>
            <div className="section_sponsors_join">
              {webinar && webinar.cpd_points && !isCustomCertificate ? (
                <CPDPoints webinar={webinar} />
              ) : null}

              {isCertificateOfParticipation && (
                <p>Certificate of Participation</p>
              )}

              {joined &&
                moment(end_date) < moment() &&
                (cpd_status === CPD_STATUSES.granted ||
                  isCustomCertificate) && (
                  <CertificateLink token={token} webinarId={id} />
                )}
            </div>
          </div>
          {partnerships && partnerships.length && partnerships.length > 0 ? (
            <div className="partnership-title-mobile">
              <p>In partnership with:</p>
              {renderPartners(partnerships)}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="section_recorded">
      <p className="section_topic">{webinar_title}</p>
      <div className="section_info row">
        {/*<div className="col l2">*/}
        {/*  <p className="section_date">{moment(start_date).format('D/M/YYYY')}</p>*/}
        {/*  <p className="section_time">{moment(start_date).format('h:mm a').toUpperCase()}</p>*/}
        {/*</div>*/}
        <div className="col l4 webinar_title">
          <p className="section_live_theme"></p>
        </div>
        <div className="col l2 section_topic">
          <p className="current_card_date">
            <span>{moment(start_date).format("D/M/YYYY").toUpperCase()} </span>
            {/*{moment(start_date).format('YYYY')}*/}
          </p>
          <p className="current_card_time">
            {moment(start_date).format("h:mm a").toUpperCase()}
            {" - "}
            {moment(end_date).format("h:mm a").toUpperCase()}
          </p>
        </div>

        <div className="col l3">
          <p>Sponsored by:</p>
          {renderSponsors(sponsor, sponsors, false)}
        </div>
        {webinar && webinar.cpd_points && !isCustomCertificate ? (
          <div className="col l2">
            <p className="section_recorded_points">
              <b>CPD Points</b>
            </p>
            <p>{cpdPoints(webinar)}</p>
          </div>
        ) : null}

        {isCertificateOfParticipation && (
          <div className="col l2">
            <p>Certificate of Participation</p>
          </div>
        )}

        {joined &&
          moment(end_date) < moment() &&
          (cpd_status === CPD_STATUSES.granted || isCustomCertificate) && (
            <CertificateLink token={token} webinarId={id} />
          )}
      </div>
      {renderExperts(experts)}
    </div>
  );
};

CpdLiveItem.propTypes = {
  webinar: PropTypes.obj,
};

export default CpdLiveItem;



// WEBPACK FOOTER //
// ./src/components/CpdLocker/CpdLiveItem.js